import { createSlice } from "@reduxjs/toolkit"
import { ApiStatus } from "../../types/api/status"
import { RootState } from "../store"
import { Bank, bankType } from "../../types/slices/bankType"

const initialState: bankType = {
    status: ApiStatus.FETCHED,
    banks: [],
    bankSelected: {} as Bank,
    errorMessage: undefined
}

const bankSlice = createSlice({
    name: 'bankSlice',
    initialState,
    reducers: {
        onFetchBanks(state, { payload }: { payload: Bank[] }) {
            state.status = ApiStatus.FETCHED
            state.banks = payload
            state.errorMessage = undefined
        },
        onSetSelectedBank(state, { payload }: { payload: Bank }) {
            state.bankSelected = payload
        },
        changeStatus(state, { payload }: { payload: ApiStatus }) {
            state.status = payload
        }
    }
})

export const selectBankState = (state: RootState) => state.bankSlice
export default bankSlice.reducer
export const {
    onFetchBanks,
    onSetSelectedBank,
    changeStatus
} = bankSlice.actions